import type { OrgaViewFrameContext } from "../../../context"

export const canViewOrganizationSettings = (context: OrgaViewFrameContext) =>
  context.permissions.allows("core.org_settings", "view")

/** Subscription restrictions apply to every member; there is no administrator exemption. */
export const isSubscriptionRestricted = (context: OrgaViewFrameContext) =>
  context.subscriptionRestrictionActive

/** Only a member of exactly this organization may delete it; platform staff own no tenant. */
export const canDeleteOrganization = (context: OrgaViewFrameContext) =>
  Boolean(
    context.organization &&
    context.permissions.allows("core.org_settings", "manage") &&
    context.currentUserOrganizationId === context.organization.id,
  )

export const canViewBilling = (context: OrgaViewFrameContext) => {
  const authorized = context.permissions.allows("core.billing", "view")

  if (!context.billingAvailable || !context.billingEnabled || !authorized) return false

  return (
    context.billingRequiresCheckout ||
    context.tariffCapabilities.hasUsage ||
    context.permissions.allows("core.billing", "manage")
  )
}

/**
 * Declared effects of the KB membership demo reset (kehrblatt.demo_reset.enqueue_v2), including
 * the member selection and the settings and plan reset the admin workflow always requests.
 */
export const canResetDemoData = (context: Pick<OrgaViewFrameContext, "permissions">) =>
  context.permissions.allows("core.memberships", "manage") &&
  context.permissions.allows("kehrblatt.demo_reset", "manage") &&
  context.permissions.allows("kehrblatt.registry", "manage") &&
  context.permissions.allows("kehrblatt.scheduling", "manage", { scope: "all" }) &&
  context.permissions.allows("core.notifications", "manage", { scope: "all" }) &&
  context.permissions.allows("core.org_settings", "manage") &&
  context.permissions.allows("core.billing", "manage")
